import axios from 'axios'
import Const from '@/helper/const'

export default {
  sendContactInfo (data) {
    const { reCaptchaToken } = data

    delete data.reCaptchaToken

    return axios({
      method: 'post',
      url: `${Const.API_URL}/email/contact`,
      headers: {
        Recaptcha: reCaptchaToken,
        'X-Api-Key': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGkiOiIyMDgwNzY4ZS00MzEwLTRhYTctYmE4Zi01ZTU2Y2FjNTU0MzciLCJpc3MiOiJzZXJ2aWNlX2F1dGhfcmVxdWVzdF92YWxpZGF0aW9uIiwiaWF0IjoxNTk1ODc0NjUwLjAwMDcyNX0.Hi3-KJBRJuOyGQDnfZn9gaBWCIW7aPS8cwjvn9RxJ-xIGSzTb4qkH8re-WtFX5N5KdxC4nmT_RjEy3e9O7ffCCUD4hsUnrdiczdH5hlmPX3nz2ShdaBJhYELZFJ9ovubKRAnuokY5keBsxOHq6-ecrS2wAl1Vhu1GsaBtWW0KTnTF4w4Bkpv9ksy6z4N4RCoA6O4Z-KYfUrWbPCR5zEHXY69CIH-hNRxnRc59b-iOVUnn7FrSRA-m1WaWDW0KGtu-ImTHCK8Pagf4Yx53fXuKpysHHsS1pwSfJNb6kPZwHnf4vIun7EF3oZoEPZprRK3Ps_tYINKxaZfnLLQVxcGUPCZLbk0ohkJcBECUHkkIOqDl_xPflgz_Cmh0msP8uDL936h7QTOinwQWbwoylWNHYdrTZHgwUV_LzW7emdpxj4AIx7H2Ievc6boPQeO4EruF7AXTKxHj0l7NL9Q36KrQa-s6O-A4fwlcX94mvwxciepgT-PfiwpLhZmJruhz68gwpWadGP4sftfhtq7K1kSrAYIVcoazxg9EhucYzyrpL683aP8kWjvTAN5ahPF8oVReeQOa541bDsoNmUJWVOZhbVbFl7OGbvsBjX-zItUBnTsNUvt5JVluTg_w8Xl3Ymni8knJVGUxjuNYSxGtbhMFlSFPZ-jUiXFeWK6I4MD_Pw'
      },
      data
    })
  }
}
